import React, { useEffect, useState, useRef } from "react";
import HeaderComponent from "../../Components/Header/header";
import "./cotizador.css";
import useCotizadorStore from "../../Stores/cotizadorStore";
import { Button, TextField } from "@mui/material";
import jsPDF from "jspdf";

function CotizadorViewComponent() {
  const hoy = new Date();
  const cotizador = useCotizadorStore((state) => state.cotizador);
  const reportTemplateRef = useRef(null);

  useEffect(() => {
    let total = 0;
    cotizador.forEach((el) => {
      total += el.qty * el.price;
    });
    setSubTotal(total);
  }, [cotizador]);

  useEffect(() => {
    if(localStorage.getItem('cotizacionData')){
      setDataCotizacion({...JSON.parse(localStorage.getItem('cotizacionData'))})
      setCotizadorSet(true)
    }
  }, [])

  const [subTotal, setSubTotal] = useState(0);
  const [dataCotizacion, setDataCotizacion] = useState({});
  const [cotizadorSet, setCotizadorSet] = useState(false);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const handleGeneratePdf = () => {
    const doc = new jsPDF("p", "pt", "a4");

    // Adding the fonts.
    doc.setFont("Inter-Regular", "normal");

    doc.html(reportTemplateRef.current, {
      autoPaging: "text",
      html2canvas: {
        scale: 0.66,
      },
      async callback(doc) {
        await doc.save("document");
      },
    });
  };

  const sendCotizacionYPrint = () => {
    let fetchData = {
      method: "POST",
      body: JSON.stringify({ ...dataCotizacion, cotizacion: cotizador }),
      headers: new Headers({
        "Content-Type": "application/json; charset=UTF-8",
      }),
    };
    fetch("https://grupo-serdan-back-iplv-dev.fl0.io/api/sendmail", fetchData)
      .then(() => {
        handleGeneratePdf()
      })
  }

  const saveCotizacionData = () => {
    if(dataCotizacion.name && dataCotizacion.email && dataCotizacion.phone){
      localStorage.setItem('cotizacionData', JSON.stringify(dataCotizacion))
      setCotizadorSet(true)
    }
  };

  return (
    <section>
      <HeaderComponent />
      {!cotizadorSet && (
        <div
          className="resumen-page cotizador-container"
          style={{ textAlign: "center", marginTop: "200px" }}
        >
          <h2>Para generar la cotización porfavor ingrese sus datos</h2>
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Nombre"
            className="mb-2"
            onChange={(e) =>
              setDataCotizacion({ ...dataCotizacion, name: e.target.value })
            }
          />
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Correo"
            className="mb-2"
            onChange={(e) =>
              setDataCotizacion({ ...dataCotizacion, email: e.target.value })
            }
          />
          <TextField
            variant="outlined"
            fullWidth
            placeholder="Teléfono"
            className="mb-2"
            onChange={(e) =>
              setDataCotizacion({ ...dataCotizacion, phone: e.target.value })
            }
          />
          <Button
            onClick={saveCotizacionData}
            color="success"
            style={{ marginTop: "15px", marginBottom: "15px" }}
            variant="contained"
          >
            Enviar
          </Button>
        </div>
      )}

      {cotizadorSet && (
        <div className="resumen-page" style={{ textAlign: "center" }}>
          <div className="cotizador-container" ref={reportTemplateRef}>
            <p style={{ marginBottom: "15px", fontWeight: "700" }}>
              Fecha de Emisión: {hoy.getDate()}/{hoy.getMonth()}/
              {hoy.getFullYear()}
            </p>
            <p style={{ marginBottom: "15px", fontWeight: "700" }}>
              Cotización de productos Comercializadora CASAR
            </p>
            <p>
              A razón de su interés por nuestros productos, Comercializadora
              CASAR pone a su disposición la siguiente cotización:
            </p>

            <table className="cotizador-table">
              <tr>
                <th>Nombre de producto</th>
                <th>Unidades</th>
                <th>Marca</th>
                <th>Precio</th>
              </tr>
              {cotizador.map((el) => (
                <tr>
                  <td>{el.name}</td>
                  <td>{el.qty}</td>
                  <td>
                    {el.tag?.filter((tag) => tag.tagType === "marca")[0]
                      ? el.tag?.filter((tag) => tag.tagType === "marca")[0]
                          .tagName
                      : ""}
                  </td>
                  <td>{formatter.format(Number(el.price))}</td>
                </tr>
              ))}
            </table>

            <div
              className="total-container"
              style={{ width: "fit-content", marginRight: "auto" }}
            >
              <div className="total-amount-container">
                <span style={{ marginRight: "100px" }}>Subtotal</span>
                <span className="total-container-price">
                  {formatter.format(Number(subTotal))}
                </span>
              </div>
              <div className="total-amount-container">
                <span>Costo de envío</span>
                <span className="total-container-price">
                  {formatter.format(Number(199))}
                </span>
              </div>
              <div className="total-amount-container total-ammount-container">
                <span>Total</span>
                <span className="total-container-price total-ammount-price">
                  {formatter.format(Number(subTotal + 199))}
                </span>
              </div>
            </div>
          </div>
          <Button
            onClick={sendCotizacionYPrint}
            color="success"
            style={{ marginTop: "15px", marginBottom: "15px" }}
            variant="contained"
          >
            Imprimir
          </Button>
        </div>
      )}
    </section>
  );
}

export default CotizadorViewComponent;
